// extracted by mini-css-extract-plugin
module.exports = {"PaymentWelcome":"PaymentWelcome_PaymentWelcome__Jakq9","card":"PaymentWelcome_card__EPXVZ","btn":"PaymentWelcome_btn__t6e_T"};